import {
  getContent,
  mergeContent,
  newModal,
  mergeModalState,
  closeModal,
} from "@js/helpers/state.js";

import {
  CE_MODAL_UPLOAD_FROM_URL_OPEN,
  CE_MODAL_UPLOAD_FROM_URL_REOPEN,
  CE_MODAL_UPLOAD_FROM_URL_SAVE_STARTED,
  CE_MODAL_UPLOAD_FROM_URL_SAVE_FAILURE,
  CE_MODAL_UPLOAD_FROM_URL_SAVE_SUCCESS,
} from "@js/actions/studio/campaign_content_section/modal_upload_from_url.js";

let preprocess = (state) => {
  // Trim leading and trailing whitespace off the URL.

  let { url } = state.modal.state;

  return mergeModalState(state, { url: url.trim() });
};

let validate = (state) => {
  let { url } = state.modal.state;

  // Validate the presence of the URL.

  if (url.length === 0) {
    return t("phrases.react_content.url_not_blank");
  }

  // Validate the URL begins with http:// or https://

  try {
    let jsUrl = new URL(url);

    if (!["http", "https", "http:", "https:"].includes(jsUrl.protocol)) {
      return t("phrases.react_content.url_must_begin");
    }
  } catch (e) {
    return t("phrases.react_content.invalid_url");
  }

  return null;
};

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_UPLOAD_FROM_URL_OPEN: {
      return newModal(state, "upload_from_url", {
        step: "enter_url",
        client_content_id: action.client_content_id,
        url: "",
        format: null, // are we writing the data to text or html?
        validation_error: null,
        download_error: null,
      });
    }

    case CE_MODAL_UPLOAD_FROM_URL_REOPEN: {
      return mergeModalState(state, {
        step: "enter_url",
        format: null, // are we writing the data to text or html?
        validation_error: null,
        download_error: null,
      });
    }

    case CE_MODAL_UPLOAD_FROM_URL_SAVE_STARTED: {
      let preprocessedState = preprocess(state);
      let error = validate(preprocessedState);

      if (error) {
        return mergeModalState(state, {
          validation_error: error,
        });
      }

      return mergeModalState(state, {
        step: "downloading",
        format: action.format,
        validation_error: null,
      });
    }

    case CE_MODAL_UPLOAD_FROM_URL_SAVE_FAILURE: {
      return mergeModalState(state, {
        step: "download_error",
        download_error: action.error,
      });
    }

    case CE_MODAL_UPLOAD_FROM_URL_SAVE_SUCCESS: {
      let { client_content_id, format: dstFormat } = state.modal.state;
      let content = getContent(state, client_content_id);

      // We may need to upgrade from "html" or "text" to "both" if we didn't
      // already include the format that we're writing.
      let newFormat =
        content.format == "both" || content.format == dstFormat
          ? content.format
          : "both";

      return mergeContent(closeModal(state), client_content_id, {
        [dstFormat]: action.data,
        format: newFormat,
        active_html_editor:
          dstFormat === "html" ? "textarea" : content.active_html_editor,
      });
    }

    default:
      return state;
  }
};
